module.exports = __webpack_public_path__ + "static/10-d4dd5fd6ec8ce60891b70996f1512635.jpg";